module.exports = __webpack_public_path__ + "img/certificate-1.50daab57.png";